<div class="itemAligner">
<ng-container *ngIf="cardDeck$ | async as cardDeck">
  <ng-container *ngFor="let cp of cardDeck.cardPatterns">
    <em-pattern-card [rightSidenav]="rightSidenav" [cardPatternId]="cp.id" [cardDeckId]="cp.cardDeckId" [cardDeckType]="cardDeck.type" [showSelectToggle]="false"></em-pattern-card>
  </ng-container>
</ng-container>
</div>
